// extracted by mini-css-extract-plugin
module.exports = {"title":"_34jM_pJljD","head":"_2XW8Gw9MVQ","id":"_2TTr7yGG2a","tabs":"omjnfU9KmB"};
    if(module.hot) {
      // 1597843255362
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  